import * as ActionCreators from './action-creators';
import { AsyncAction, BankAccountView } from 'models';
import services from 'services';

export const fetchBankAccounts = (coopId: string): AsyncAction => {
  return async (dispatch) => {
    dispatch(ActionCreators.requestBankAccounts());

    try {
      const bankAccounts: BankAccountView[] = (
        await services.get(`/api/cooperatives/${coopId}/bank-accounts`)
      ).data.Data;

      dispatch(ActionCreators.requestBankAccountsSuccess(bankAccounts));
    } catch (err) {
      console.error(err);
      dispatch(ActionCreators.requestBankAccountsFailed());
    }
  };
};
